export const normalizeEmptyStringsToNull = (obj) => {
  const cleaned = {};
  for (const key in obj) {
    const value = obj[key];
    cleaned[key] = value === "" ? null : value;
  }
  return cleaned;
};

export const getEventTypeIdFromIndustry = (industry) => {
  if (!industry) return null;
  const isShipping = industry.toLowerCase() === "shipping";
  if (isShipping) {
    return "ce5e066f-cb4a-4a0e-83ce-018c3b4d6a39"; // Shipping Event Type ID
  } else {
    return "7fc7a847-a119-45d8-9a2a-ae15952881c7"; // Aviation Event Type ID
  }
};
